import { render, staticRenderFns } from "./Services-Item.vue?vue&type=template&id=35e41b63&"
import script from "./Services-Item.vue?vue&type=script&lang=ts&"
export * from "./Services-Item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports